export var handleBackgroundBlur = function (isEnabled) {
    var backgroundElementIds = ['ReactShellHeader', 'officeHome'];
    backgroundElementIds.forEach(function (id) {
        var element = document.getElementById(id);
        if (element) {
            element.style.filter = isEnabled ? 'blur(7px)' : 'none';
        }
    });
};
//# sourceMappingURL=handleBackgroundBlur.js.map